export type DomainMatcher = string | Array<string | RegExp> | RegExp;

export const WILDCARD = '*';

export const isRegex = (item): boolean => {
  return Object.prototype.toString.call(item) === '[object RegExp]';
};

export const matchDomain = (pattern: DomainMatcher, origin: DomainMatcher): boolean => {
  if (typeof pattern === 'string') {
    if (typeof origin === 'string') {
      return pattern === WILDCARD || origin === pattern;
    }

    if (isRegex(origin)) {
      return false;
    }

    if (Array.isArray(origin)) {
      return false;
    }
  }

  if (isRegex(pattern)) {
    if (isRegex(origin)) {
      return pattern.toString() === origin.toString();
    }

    if (Array.isArray(origin)) {
      return false;
    }

    return Boolean((origin as string).match(pattern as RegExp));
  }

  if (Array.isArray(pattern)) {
    if (Array.isArray(origin)) {
      return JSON.stringify(pattern) === JSON.stringify(origin);
    }

    if (isRegex(origin)) {
      return false;
    }

    return pattern.some((subpattern) => matchDomain(subpattern, origin));
  }

  return false;
};

export const isFrameWindowClosed = (frame): boolean => {
  if (!frame.contentWindow) {
    return true;
  }

  if (!frame.parentNode) {
    return true;
  }

  const doc = frame.ownerDocument;

  if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
    let parent = frame;

    while (parent.parentNode && parent.parentNode !== parent) {
      parent = parent.parentNode;
    }

    if (!parent.host || !doc.documentElement.contains(parent.host)) {
      return true;
    }
  }

  return false;
};
